import { Hobby } from '../../types/models/hobby/hobby'
import { HobbyInput } from '../../types/models/hobby/hobby-input'

export const toHobbyInput = (hobby?: Hobby): HobbyInput | undefined => {
  if (!hobby) return undefined

  return {
    name: hobby.name,
    description: hobby.description,
    visibleTo: hobby.visibleTo,
    picto: hobby.picto
  }
}
